'use client'

import { createContext, useCallback, useContext, useState } from 'react'
import { IChildrenProps } from '@/utils/typings/children-props'
import { noOp } from '@/utils/functions/no-op'
import { IModalName } from '@/features/modal/modal-names'

interface IModalContext {
    openModal: IModalName | null
    closeModal: () => void
    setOpenModal: (modalName: IModalName) => void
    toggleModal: (modalName: IModalName) => void
}

const ModalContext = createContext<IModalContext>({
    openModal: null,
    closeModal: noOp,
    setOpenModal: noOp,
    toggleModal: noOp,
})

type IModalProviderProps = IChildrenProps

export function ModalProvider({ children }: IModalProviderProps) {
    const [openModal, setOpenModal] = useState<IModalName | null>(null)

    const closeModal = useCallback(() => {
        setOpenModal(null)
    }, [])

    const toggleModal = useCallback((modalName: IModalName) => {
        setOpenModal((prev) => (prev === modalName ? null : modalName))
    }, [])

    return (
        <ModalContext.Provider value={{ openModal, closeModal, setOpenModal, toggleModal }}>
            {children}
        </ModalContext.Provider>
    )
}

export function useModalContext() {
    return useContext(ModalContext)
}
